import Button from '@/components/common/Button';
import type {ConfirmModalProps} from '@/components/DeactivateAccount/types';

import Modal from '.';

const ConfirmationModal: React.FC<
  React.PropsWithChildren<ConfirmModalProps>
> = ({
  isOpen,
  label,
  cancelAction,
  cancelActionLabel,
  confirmAction,
  confirmActionLabel,
  loadingLabel,
  loading,
  title,
  width,
  dataCy,
  children,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={cancelAction}
      width={width || 'w-80'}
      height="h-auto"
      title={title}
      dataCy={dataCy}
      zIndex={99}
      hideX
    >
      <p
        data-cy={dataCy ? `${dataCy}-text` : undefined}
        className="justify-self-center gap-2 justify-center text-center text-gray-800 dark:text-white w-72 text-sm"
      >
        {label}
      </p>

      {children}

      <div className="flex justify-evenly mt-10 mb-10">
        <Button
          colorScheme="green"
          onClick={confirmAction}
          className="h-10"
          isLoading={loading}
          loadingText={loadingLabel}
          dataCy={dataCy ? `${dataCy}-confirm` : undefined}
        >
          {confirmActionLabel}
        </Button>

        <Button
          colorScheme="red"
          onClick={cancelAction}
          className="h-10"
          disabled={loading}
          dataCy={dataCy ? `${dataCy}-cancel` : undefined}
        >
          {cancelActionLabel}
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
